import { render, staticRenderFns } from "./EmptyArea.vue?vue&type=template&id=16a5ca92&scoped=true&"
import script from "./EmptyArea.vue?vue&type=script&lang=js&"
export * from "./EmptyArea.vue?vue&type=script&lang=js&"
import style0 from "./EmptyArea.vue?vue&type=style&index=0&id=16a5ca92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a5ca92",
  null
  
)

export default component.exports